import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Token from './components/Token';
import Documentation from './components/Documentation';
import Footer from './components/Footer';
import VideoPage from './pages/VideoPage';
import MembersArea from './components/MembersArea';
import BotRequestForm from './components/BotRequestForm';
import Dashboard from './components/Dashboard';
import Academy from './academy/pages/Academy';
import Course from './academy/pages/Course';
import NFTMint from './components/NFTMint';
import Partnerships from './components/Partnerships';
import { AuthProvider } from './academy/context/AuthContext';

// Main home page content
const Home = () => (
  <div className="home-container">
    <Navbar />
    <Hero />
    <About />
    <Token />
    <Footer />
  </div>
);

// Documentation page with navigation
const DocumentationPage = () => (
  <>
    <Navbar />
    <Documentation />
    <Footer />
  </>
);

// Bot Request page with navigation
const BotRequestPage = () => (
  <>
    <Navbar />
    <BotRequestForm />
    <Footer />
  </>
);

// Test page for debugging routes
const TestPage = () => (
  <div style={{ padding: '50px', background: '#282c34', color: 'white', minHeight: '100vh' }}>
    <h1>Test Route Works!</h1>
    <p>If you can see this, routing is working correctly.</p>
    <a href="/academy" style={{ color: 'cyan' }}>Back to Academy</a>
  </div>
);

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/documentation" element={<DocumentationPage />} />
            <Route path="/members" element={<MembersArea />} />
            <Route path="/video" element={<VideoPage />} />
            <Route path="/request-bot" element={<BotRequestPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/academy" element={<Academy />} />
            <Route path="/academy/course/:courseId" element={<Course />} />
            <Route path="academy/course/:courseId" element={<Course />} />
            <Route path="/test" element={<TestPage />} />
            <Route path="/nft" element={<NFTMint />} />
            <Route path="/partnerships" element={<Partnerships />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
};

export default App;